import { useQuery } from "react-query";
import { pos } from "@/platform";

export const ENTRADAS_CON_PIN_QUERY_KEY = "caja-entradas-con-pin";

/**
 * Las cajas del equipo en las que se entra con PIN sin sesión (#346 AC-2;
 * §2.6). Sale del almacén de la caja, no del servidor: en la web no hay.
 */
export function useEntradasConPin() {
  return useQuery(ENTRADAS_CON_PIN_QUERY_KEY, () => pos.pinEntries(), {
    enabled: pos.isAvailable,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
